
(function () {
  'use strict';

  function enhance(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.sr-feature'), function (card) {
      if (card.getAttribute('data-sr-enh')) return;
      card.setAttribute('data-sr-enh', '1');
      var sp = card.querySelector('span');
      if (!sp) return;
      if (sp.scrollHeight > sp.clientHeight + 3) {
        card.classList.add('sr-more');
        card.addEventListener('click', function () { card.classList.toggle('sr-open'); });
      }
    });
  }

  // §23.520. enhance() читает scrollHeight/clientHeight — это принудительная
  // компоновка. На DOMContentLoaded она (1) удлиняла общую задачу defer-скриптов
  // и (2) заставляла браузер отрисовать секцию характеристик, которую §23.519
  // нарочно не рисует до прокрутки (content-visibility:auto; web.dev: «avoid
  // calling DOM APIs that force rendering on a skipped subtree»). Теперь карточка
  // измеряется, когда впервые попадает в окно просмотра.
  // §23.888: глубина в схеме размеров была подписана символом U+2198; iPhone рисует его как эмодзи
  // (синий квадрат). В уже сохранённых описаниях меняем символ на тонкую линию, как у высоты и ширины.
  // Только атрибуты и DOM, без замеров: секцию до прокрутки не рисуем.
  function fixDepth(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.sr-dims svg text'), function (t) {
      var s = t.textContent || '';
      if (s.charAt(0) !== '\u2198') return;
      var x = parseFloat(t.getAttribute('x')), y = parseFloat(t.getAttribute('y'));
      if (isNaN(x) || isNaN(y)) return;
      var x0 = x - 8, ln = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      ln.setAttribute('class', 'meas');
      ln.setAttribute('x1', x0 + 4); ln.setAttribute('y1', y - 11);
      ln.setAttribute('x2', x0 + 12); ln.setAttribute('y2', y - 3);
      t.parentNode.insertBefore(ln, t);
      t.textContent = s.replace(/^\u2198\s*/, '');
      t.setAttribute('x', x0 + 16);
    });
  }

  function boot() {
    fixDepth(document);
    if (!window.IntersectionObserver) { enhance(document); return; }
    var cards = document.querySelectorAll('.sr-feature');
    if (!cards.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        enhance(en.target.parentNode || document);
      });
    }, { rootMargin: '200px 0px' });
    Array.prototype.forEach.call(cards, function (c) { io.observe(c); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.SpecsRenderer = { enhance: enhance };
})();
